import * as moment from 'moment-timezone'

/**
 * Takes in a date string, e.g., 1998-5-9, and adds leading zeroes
 * to the month and day if necessary, resulting in a output
 * like 1998-05-09
 * @param dateString Date in format YYYY-MM-DD
 * @returns A date string with leading zeroes added to MM and DD
 */
export const formatDateWithLeadingZeroes = (dateString: string) => {
  const dateFormat = 'YYYY-MM-DD'

  // Define String + Format here to avoid deprecation warning for dates
  // not in RFC2822 or ISO format and enable cross-browser compatibility
  return moment(dateString, dateFormat).format(dateFormat)
}
